export default __webpack_public_path__ + "static/media/testimonial-01.a570a055.jpg";